import { render, staticRenderFns } from "./BulkActionActiveIcon.vue?vue&type=template&id=9b3aa048"
import script from "./BulkActionActiveIcon.vue?vue&type=script&lang=js"
export * from "./BulkActionActiveIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports